import { getDistanceKm } from "@/lib/getDistance";
import { Branch, BranchResponse } from "@/types/branches";
import { useQuery } from "@tanstack/react-query";


export interface UserLocation {
    lat: number;
    lon: number;
}

export function useBranches(userLocation: UserLocation | null) {
    return useQuery<Branch[]>({
        queryKey: ["branches", userLocation],
        queryFn: async () => {
            const apiUrl = import.meta.env.VITE_API_URL || import.meta.env.NEXT_PUBLIC_API_URL || ''
            const res = await fetch(`${apiUrl}/v1/branches`);
            const json: BranchResponse = await res.json();

            const branches = json.data;

            // If no geolocation → return unsorted
            if (!userLocation) return branches;

            try {

                const sorted = [...branches].sort((a, b) => {
                    const coordsA = a.location?.coordinates?.coordinates;
                    const coordsB = b.location?.coordinates?.coordinates;

                    // If coordinates are missing → send to bottom of list
                    if (!coordsA || !coordsB) {
                        return 0;
                    }

                    const [lon1, lat1] = coordsA;
                    const [lon2, lat2] = coordsB;

                    const d1 = getDistanceKm(userLocation!.lat, userLocation!.lon, lat1, lon1);
                    const d2 = getDistanceKm(userLocation!.lat, userLocation!.lon, lat2, lon2);

             
                    return d1 - d2;
                });


                return sorted;
            } catch (err) {
                return branches;

            }

        },
    });
}

